export default __webpack_public_path__ + "static/media/4-snapshot.ff8a1974.png";